import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, image, url }) => {
  const siteTitle = "AgniThrust | Bio-Energy Solutions";
  const defaultDesc = "AgniThrust Private Ltd. - Leading manufacturer and exporter of secondary high-intensity bio-fuels, bio mass pellets, and bio coal.";
  const defaultKeywords = "AgniThrust, bio-fuel, biomass pellets, bio coal, sustainable energy";
  const siteUrl = "https://agnithrust.com";

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title ? `${title} | ${siteTitle}` : siteTitle}</title>
      <meta name="description" content={description || defaultDesc} />
      <meta name="keywords" content={keywords || defaultKeywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url || siteUrl} />
      <meta property="og:title" content={title || siteTitle} />
      <meta property="og:description" content={description || defaultDesc} />
      <meta property="og:image" content={image || "/logo512.png"} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url || siteUrl} />
      <meta property="twitter:title" content={title || siteTitle} />
      <meta property="twitter:description" content={description || defaultDesc} />
      <meta property="twitter:image" content={image || "/logo512.png"} />
    </Helmet>
  );
};

export default SEO;
